// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconFooterPrivacy = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="14" viewBox="0 0 29 14">
            <g fill="none">
                <path
                    fill="#1576FF"
                    d="M0,7 C0,3.134005 3.134005,0 7,0 L22,0 C25.866,0 29,3.134005 29,7 L29,7 C29,10.866 25.866,14 22,14 L7,14 C3.134005,14 0,10.866 0,7 L0,7 Z"
                />
                <path
                    fill="#FFF"
                    d="M12.8769 13 7.24615 13C3.7965 13 1 10.3137 1 7 1 3.68629 3.7965 1 7.24615 1L15.5 1 12.8769 13ZM22.3086 7.23635 24.73045 9.6582C24.79555 9.7233 24.79555 9.7949 24.73045 9.87305L24.28125 10.32225C24.2031 10.38735 24.1315 10.38735 24.0664 10.32225L23.65625 9.8926 21.64455 7.9004 19.22265 10.32225C19.15755 10.38735 19.08595 10.38735 19.0078 10.32225L18.5586 9.87305C18.4935 9.7949 18.4935 9.7233 18.5586 9.6582L20.98045 7.23635 18.5586 4.814455C18.4935 4.74935 18.4935 4.677735 18.5586 4.59961L19.0078 4.15039C19.08595 4.085285 19.15755 4.085285 19.22265 4.15039L21.64455 6.57225 24.0664 4.15039C24.1315 4.085285 24.2031 4.085285 24.28125 4.15039L24.73045 4.59961C24.79555 4.677735 24.79555 4.74935 24.73045 4.814455L24.3008 5.2246 22.3086 7.23635Z"
                />
                <path
                    fill="#1576FF"
                    d="M11.16405,4.07031 C11.2578,3.97656 11.3574,3.97656 11.4629,4.07031 L11.9551,4.58008 C12.06055,4.67383 12.06055,4.77344 11.9551,4.878905 L6.68165,10.15235 C6.5879,10.2461 6.4883,10.2461 6.3828,10.15235 L4.04492,7.7969 C3.939455,7.7031 3.939455,7.6035 4.04492,7.49805 L4.53711,7.00585 C4.64258,6.9004 4.74219,6.9004 4.83594,7.00585 L6.541,8.71095 L11.16405,4.07031 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconFooterPrivacy);
